import script from "./FeeDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./FeeDetail.vue?vue&type=script&lang=ts&setup=true"

import "./FeeDetail.vue?vue&type=style&index=0&id=3ce294ab&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ce294ab"]])

export default __exports__